import script from "./LoginDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginDialogComponent.vue?vue&type=script&lang=ts&setup=true"

import "./LoginDialogComponent.vue?vue&type=style&index=0&id=75452cdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75452cdc"]])

export default __exports__